import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './textInput.scss';

const TextInput = ({ error, placeholder, type = "text", onChange, value, textarea = false, autoComplete = "off" }) => {
  let Element;

  if (textarea) {
    Element = 'textarea'
  } else {
    Element = 'input';
  }
  return (
    <Element
      className={classnames(styles.textInput, {[styles.error]:error})}
      type={type}
      placeholder={placeholder}
      onChange={onChange}
      value={value}
    />
  )
};

TextInput.propTypes = {
  error: PropTypes.bool,
  placeholder: PropTypes.string.isRequired,
  type: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  textarea: PropTypes.bool,
  autoComplete: PropTypes.string,
};

export { TextInput };



// WEBPACK FOOTER //
// ./src/elements/textInput/textInput.js